import { render, staticRenderFns } from "./AppointmentCalendarSkeleton.vue?vue&type=template&id=dbe633f8&scoped=true&"
import script from "./AppointmentCalendarSkeleton.vue?vue&type=script&lang=js&"
export * from "./AppointmentCalendarSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentCalendarSkeleton.vue?vue&type=style&index=0&id=dbe633f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe633f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbe633f8')) {
      api.createRecord('dbe633f8', component.options)
    } else {
      api.reload('dbe633f8', component.options)
    }
    module.hot.accept("./AppointmentCalendarSkeleton.vue?vue&type=template&id=dbe633f8&scoped=true&", function () {
      api.rerender('dbe633f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentCalendarSkeleton.vue"
export default component.exports